import angular from 'angular';
import scrollTo from './scroll-to-directive';
import onServerError from './service-error-directive';

export default angular.module('app.directives', [])
    .directive('onServerError', onServerError)
    .directive('scrollTo', scrollTo);


// WEBPACK FOOTER //
// ./src/app/directives/directives.js